import React, { useState } from "react";

function Self_life_form() {
  const [selectedUnit, setSelectedUnit] = useState("Select");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const units = ["Year", "Month", "Days"];

  return (
    <div className="p-5 border-2 border-gray-300 rounded-xl my-5">
      <p className="font-semibold text-gray-600 text-xl underline">
        Self Life & Expiry Details
      </p>
      <div className="w-full md:w-1/2 px-10 mt-4 ">
        <div className="flex flex-col mt-4">
          <label htmlFor="productLifeField" className="text-lg text-gray-600">
            Product Life
          </label>
          <div className="flex items-center space-x-2">
            <input
              type="text"
              id="productLifeField"
              placeholder="Enter Number"
              className=" px-4 py-1.5 text-gray-600 border border-gray-300 rounded outline-none"
            />
            <div className="relative w-full">
              <button
                onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                className="w-full px-4 py-1.5 text-gray-600 border border-gray-300 rounded flex items-center justify-between"
                type="button"
              >
                {selectedUnit}
                <svg
                  className="w-4 h-4 ml-2"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 9l-7 7-7-7"
                  ></path>
                </svg>
              </button>
              {isDropdownOpen && (
                <div className="absolute left-0 top-full mt-1 w-full bg-white border border-gray-300 rounded shadow z-10">
                  {units.map((unit) => (
                    <div
                      key={unit}
                      className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                      onClick={() => {
                        setSelectedUnit(unit);
                        setIsDropdownOpen(false);
                      }}
                    >
                      {unit}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
          <div className="flex justify-end mt-3">
            <button className="bg-gray-300 text-gray-700 px-5 py-1 rounded hover:bg-gray-400">
              Add Fields
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Self_life_form;
